import { Sidebar } from "primereact/sidebar";
import React from "react";
import Loading from "../../../../components/Loading/Loading";
import localeText from "../../../../locale";
import AllSearchInputs from "./components/AllSearchInputs/AllSearchInputs";

const FiltersInSearch = ({
  searchParams,
  setSearchParams,
  visible,
  onHide,
  isLoading,
  storeNames,
  isLoadingStoreNames,
  fringeBenefitsSubCategories,
}) => {
  return (
    <>
      <Sidebar visible={visible} position="right" onHide={onHide} style={{ width: "13.5rem" }}>
        <h5>{localeText("filters")}</h5>
        <hr />
        {isLoadingStoreNames ? (
          <Loading classNameIcon="text-4xl" />
        ) : (
          <div>
            <AllSearchInputs
              isLoading={isLoading}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              storeNames={storeNames}
            />
          </div>
        )}
      </Sidebar>

      <div
        className="lg:block hidden p-3 mr-3 bg-white border-gray-300 border-solid border-1 border-round-lg justify-self-start"
        style={{ minWidth: "11rem", width: "11em" }}
      >
        {/* <h5 className="px-4">{localeText("filters")}</h5>
        <hr /> */}
        {isLoadingStoreNames ? (
          <Loading classNameIcon="text-4xl" />
        ) : (
          <div className="">
            <AllSearchInputs
              isLoading={isLoading}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              storeNames={storeNames}
              fringeBenefitsSubCategories={fringeBenefitsSubCategories}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default FiltersInSearch;
